var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"max-width":_vm.width,"persistent":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_c('v-card',{staticClass:"rounded-lg pa-4"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }